import { render, staticRenderFns } from "./OperationSafetyPage.vue?vue&type=template&id=067c4374&scoped=true"
import script from "./OperationSafetyPage.vue?vue&type=script&lang=js"
export * from "./OperationSafetyPage.vue?vue&type=script&lang=js"
import style0 from "./OperationSafetyPage.vue?vue&type=style&index=0&id=067c4374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067c4374",
  null
  
)

export default component.exports